import React from 'react'
import HeaderPanel from './HeaderPanelNew';

const Analytics = (props) => {

    return (
        <div className="top-margin dashboard execution-performance">
            <HeaderPanel workspace={props.workspace} />
        </div>
    );
};

export default Analytics;